import { render, staticRenderFns } from "./OrderDeliveringIframe.vue?vue&type=template&id=0e108b3f&"
import script from "./OrderDeliveringIframe.vue?vue&type=script&lang=ts&"
export * from "./OrderDeliveringIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports